import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

const EditorStateUpdatePlugin = ({ editorState }: { editorState: string }) => {
	const [editor] = useLexicalComposerContext();

	useEffect(() => {
		editor.update(() => {
			const updatedEditorState = editor.parseEditorState(editorState);
			editor.setEditorState(updatedEditorState);
		});
	}, [editorState, editor]);

	return null;
};

export default EditorStateUpdatePlugin;
